<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">仓库</div>
                    <el-select v-model="searchData.SId" :loading="loading" class="search-item" size="small" @change="handleChange" filterable clearable remote>
                        <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                        >
                    </el-select>
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    <div class="search-name">品牌</div>
                    <div class="search-item goods-categories">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">汽配分类</div>
                    <div class="search-item goods-categories">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            remote
                            :remote-method="searchGoodsType"
                            v-select-scroll-more="searchGoodsTypeLoad"
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn" type="primary" v-if="permission.updateSafeDays" @click="updateSafeDays">{{
                        permission.updateSafeDays
                    }}</el-button>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    ref="multipleTable"
                    border
                    style="width: 100%"
                    :row-key="getRowKeys"
                    @selection-change="handleSelectionChange"
                    :default-sort="{ prop: 'RelCount', order: 'descending' }"
                >
                    <el-table-column type="selection" width="55" reserve-selection v-if="permission.updateSafeDays" fixed="left"></el-table-column>
                    <el-table-column show-overflow-tooltip width="55px" type="index" :index="indexMethod" label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="GoodName" label="汽配名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="APCode" label="汽配编码"></el-table-column>
                    <!-- <el-table-column show-overflow-tooltip min-width="100px" prop="GoodCode" label="互换码"></el-table-column> -->
                    <el-table-column show-overflow-tooltip min-width="100px" prop="AutoSerise" label="适用车型"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="Brand" label="品牌"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="APCate" label="分类"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" sortable prop="InvenCount" label="现有库存"></el-table-column>
                    <el-table-column show-overflow-tooltip width="80" sortable prop="TotalSurplus" label="留余">
                        <template slot-scope="scope">
                            <div style="color: red" v-if="scope.row.SafeSto > scope.row.TotalSurplus">
                                {{ scope.row.TotalSurplus }}
                            </div>
                            <div v-else>{{ scope.row.TotalSurplus }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="110" prop="TotalSale" label="30天销售量">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <img
                                    src="@/assets/images/analysis.png"
                                    style="width: 22px; height: 22px; margin-left: 6px"
                                    title="数据分析"
                                    @click="showSaleStat(scope.row)"
                                />
                            </div>
                            {{ scope.row.TotalSale }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="120" prop="AvgDay" label="日均销售量"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="110" prop="SafeDay" label="安全天数"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" sortable prop="SafeSto" label="安全库存"> </el-table-column>
                    <el-table-column show-overflow-tooltip width="100" sortable prop="RelCount" label="补货数">
                        <template slot-scope="scope">
                            <div style="color: red" v-if="scope.row.SafeSto > scope.row.TotalSurplus">
                                {{ scope.row.RelCount }}
                            </div>
                            <div v-else>0</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div> -->
            <el-dialog :close-on-click-modal="false" :title="SaleDialogTitle" :visible.sync="showSaleStatDialog" :append-to-body="true" width="1100px">
                <div v-if="showSaleStatDialog">
                    <saleStat @closeDialog="closeSaleStatDialog" :GoodsId="this.goodsId" :StoId="this.searchData.SId" :ShowCus="true"></saleStat>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="修改安全天数" :visible.sync="isShowUpdate" width="350px" append-to-body :modal="false">
                <div class="dialog-content" v-if="isShowUpdate" v-loading="saveLoading">
                    <div class="flex" style="margin-bottom: 10px">
                        <div class="e-item2">
                            <div>输入安全天数的值</div>
                            <div>
                                <el-input-number
                                    style="width: 260px"
                                    @change="validatePositiveInteger"
                                    type="number"
                                    v-model="updateValue"
                                    controls-position="right"
                                    size="small"
                                    :min="0"
                                >
                                </el-input-number>
                            </div>
                        </div>
                    </div>
                    <div class="dialog-footer" style="text-align: right">
                        <el-button size="small" @click="closeUpdateDialog" :disabled="saveLoading">取消</el-button>
                        <el-button class="btn-primary" size="small" :disabled="saveLoading" @click="confirmUpdate">确定</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import saleStat from '@/components/business/salesManage/apSaleStat';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'APDataAnaly',
    components: {
        breadcrumb,
        saleStat
    },
    data() {
        return {
            showSaleStatDialog: false,
            loading: false,
            saveLoading: false,
            brand: [],
            typeList: [],
            SaleDialogTitle: '',
            PurchaseDialogTitle: '',
            searchData: {
                Symbol: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                Invent1: 0,
                Invent2: 0,
                page: 1,
                limit: 15
            },
            labelTotalCost: 0,
            dialogVisible: false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            WarehouseList: [],
            permission: {},
            // 用于汽配分类列表，分页搜索
            typeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            goodsId: '',
            multipleSelection: null,
            updateValue: 0,
            isShowUpdate: false
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('APDataAnaly');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getWarehouse();
    },
    watch: {
        dialogVisible(value) {
            if (!value) {
                this.choosedGood = {};
            }
        }
    },
    methods: {
        validatePositiveInteger(value) {
            const reg = /^[1-9]\d*$/;
            if (!reg.test(value)) {
                this.$message.warning('请输入正整数！');
                this.updateValue = parseInt(value) || 1;
            }
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        // searchGoodsType() {
        //     this.$util
        //         .getEntpApCategoryList()
        //         .then(data => {
        //             if (!data) return;
        //             this.typeList = data;
        //         })
        //         .catch(() => {});
        // },
        searchGoodsType(key) {
            if (![undefined].includes(key)) {
                this.typeForm.Page = 1;
                this.typeForm.stopLoad = false;
                this.typeForm.key = key;
                this.typeList = [];
            }
            if (this.typeForm.stopLoad) return;
            this.$util
                .getEntpApCategoryList(this.typeForm.key, this.typeForm.Page, this.typeForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.typeForm.stopLoad = data.length < this.typeForm.Limit;
                    this.typeList = [...this.typeList, ...data];
                })
                .catch(() => {});
        },
        // 客户名称列表，加载更多
        searchGoodsTypeLoad() {
            this.typeForm.Page += 1;
            this.searchGoodsType();
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                Symbol: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                Invent1: 0,
                Invent2: 0,
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 关闭弹窗
        closeDialog(edit) {
            this.dialogVisible = false;
            this.choosedGood = {};
            if (edit) {
                this.getTableData();
            }
        },
        // 获取数据
        getTableData() {
            if (this.searchData.Symbol) {
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(this.searchData.Invent2)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            }
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/APDataAnalyStats',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.goodsId = row.GoodsId;
                this.showSaleStatDialog = true;
            }
        },
        closeSaleStatDialog() {
            this.showSaleStatDialog = false;
        },
        getWarehouse() {
            let that = this;
            that.$util.getWarehouse(1).then(data => {
                if (data && data.length > 0) {
                    that.WarehouseList = data;
                    let firstWH = data[0];
                    that.searchData.SId = firstWH.WarehouseId;
                    this.getTableData();
                } else {
                    this.$util.warningMsg('您还没有相关仓库的权限，请先设置权限');
                    return;
                }
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        updateSafeDays() {
            let that = this;
            if (!that.multipleSelection || that.multipleSelection.length == 0) {
                this.$util.warningMsg('请选择要修改安全天数的商品');
                return;
            }
            if (!that.searchData.SId) {
                this.$util.warningMsg('请选择仓库');
                return;
            }
            this.isShowUpdate = true;
        },
        closeUpdateDialog() {
            this.isShowUpdate = false;
        },
        confirmUpdate() {
            let that = this;
            if (!that.updateValue) {
                that.$util.warningMsg('请输入安全天数');
                return;
            }

            let ids = [];
            that.multipleSelection.forEach(e => {
                ids.push(e.GoodsId);
            });
            that.$util.elConfirm({
                content: '谨慎操作！是否确定要修改这些商品的安全天数吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/SaveGoodsSafeDaysForSto',
                            data: {
                                GoodsIds: ids,
                                SafeDay: that.updateValue,
                                StoId: that.searchData.SId
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('更新成功');
                                that.$refs.multipleTable.clearSelection();
                                that.multipleSelection = [];
                                that.closeUpdateDialog();
                                that.getTableData();
                            } else that.$util.errorMsg(res.errmsg);
                        });
                }
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.GoodsId;
        },
        handleChange(val) {
            this.$refs.multipleTable.clearSelection();
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }

        .el-button {
            padding: 0;
        }
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 22px;
        height: 22px;
        margin-right: 10px;
    }
    .image-cus {
        width: 22px;
        height: 22px;
    }
}
</style>
